import type { FC, ReactNode } from "react";
import styles from "./Table.module.css";

export interface TableColumn {
  header: string;
  key: string;
}

export interface TableRow {
  [key: string]: string | ReactNode;
}

interface TableProps {
  columns: TableColumn[];
  rows: TableRow[];
  highlightedColumn?: string | null;
  firstColumnHeader?: boolean;
  className?: string;
  stackedMobile?: boolean;
}

export const Table: FC<TableProps> = ({ 
  columns, 
  rows, 
  highlightedColumn, 
  firstColumnHeader = true,
  className,
  stackedMobile = false
}) => {
  if (stackedMobile) {
    return (
      <div className={`${styles.table} ${styles.stackedMobile} ${className || ''}`}>
        {rows.map((row, rowIndex) => (
          <div key={rowIndex} className={styles.mobileRow}>
            {columns.map((column, columnIndex) => {
              const isFirstColumn = columnIndex === 0;
              const isHighlighted = highlightedColumn === column.key;
              
              return (
                <div key={column.key} className={styles.mobileStack}>
                  <div className={`${styles.header} ${styles.cell}`}>
                    {column.header}
                  </div>
                  <div 
                    className={`
                      ${styles.cell} 
                      ${isHighlighted ? styles.highlightedCell : ""}
                      ${(isFirstColumn && firstColumnHeader) ? styles.header : ""}
                    `}
                  >
                    {row[column.key]}
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={`${styles.table} ${className || ''}`}>
      {columns.map((column, indexColumn) => (
        <div key={column.key} className={styles.column}>
          <div className={`${styles.header} ${styles.cell}`}>
            {column.header}
          </div>
          {rows.map((row, indexRow) => {
            const isFirstColumn = indexColumn === 0;
            const isHighlighted = highlightedColumn === column.key;

            return (
              <div
                key={indexRow}
                className={`
                  ${styles.cell} 
                  ${isHighlighted ? styles.highlightedCell : ""}
                  ${(isFirstColumn && firstColumnHeader) ? styles.header : ""}
                `}
              >
                {row[column.key]}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default Table;